import React from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import AttendanceForm from "./Components/AttendanceForm";
import Loader from "./Components/Loader";

const AttendanceFormPage=()=>{
    return(
        <>
            <Header />
            <Loader />
                <AttendanceForm/>
            <Footer/>
        </>
    );
}

export default AttendanceFormPage;